<span
  (mouseenter)="onShowTooltip($event)"
  (mouseleave)="onHideTooltip()"
  (click)="onHideTooltip()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <ng-content></ng-content>
</span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOffsetX]="offsetX"
  [cdkConnectedOverlayOffsetY]="offsetY"
>
  @if (!tooling) {
  <div
    class="job-detail-progressbar-container"
    [style.top]="loadingPos.top"
    [style.left]="loadingPos.left"
  >
    <mat-spinner
      class="job-detail-progressbar"
      diameter="40"
    ></mat-spinner>
  </div>
  } @else {
  <div
    class="jobDetailTooltip toolingTooltip tooltip-show"
    (mouseenter)="onShowTooltip1()"
    (mouseleave)="onHideTooltip1()"
  >
    <div class="main-container">
      <div class="job-detail-tooltip-header tooling-tooltip-header">
        <div class="job-detail-tooltip-title tooling-tooltip-title">
          <div>
            <span translate="tooling"></span>:
            <a
              class="td-link ml-5"
              [routerLink]="['/tooling', tooling.toolingCode]"
              >{{ tooling.toolingCode }}</a
            >
            @if (tooling.hasUnassignedMachineTool) {
            <mat-icon
              class="tooling-alert"
              [matTooltip]="'toolingMissingMachineAssignment' | translate"
              >warning</mat-icon
            >
            }
            <br />
            <span class="font-size-16">{{ tooling.description }}</span>
          </div>
        </div>
        <div class="header-right-container">
          <div class="item-container">
            <div class="item-title"><span translate="machines"></span>:</div>
            <div class="item-content">{{ tooling.machines?.length || 0 }}</div>
          </div>
          <div class="item-container">
            <div class="item-title"><span translate="pCodeGroup"></span>:</div>
            <div class="item-content">{{ tooling.pCodeGroup }}</div>
          </div>
        </div>
      </div>
      <div class="p-16 flex-container right-padding-0">
        <div class="left-container">
          <div class="item-container">
            <div class="item-title"><span translate="finWidth"></span>:</div>
            <div class="item-content">{{ toolingLength(tooling.finWidth) }}</div>
          </div>
          <div class="item-container">
            <div class="item-title"><span translate="legHeight"></span>:</div>
            <div class="item-content">{{ toolingLength(tooling.legHeight) }}</div>
          </div>
        </div>
        <div class="right-container">
          <div class="item-container">
            <div class="item-title"><span translate="legHeight2"></span>:</div>
            <div class="item-content">{{ toolingLength(tooling.legHeight2) }}</div>
          </div>
          <div class="item-container">
            <div class="item-title"><span translate="profile"></span>:</div>
            <div class="item-content">{{ tooling.profile }}</div>
          </div>
        </div>
      </div>
      <div class="p-16 bp-0 tooling-scroll-container">
        <table class="table-container">
          <tr>
            @for (col of shownMachineColumns; track $index) {
            <th class="job-detail-col-item job-detail-col-item-header">
              <span>{{ col.displayName | translate }}</span>
            </th>
            }
          </tr>
          @for (machine of tooling.machines; track trackByKey($index, machine)) {
          <tr class="hover order-detail-item">
            @for (col of shownMachineColumns; track $index) {
            <td class="job-detail-col-item">
              @if (col.isBool) { @if (isChecked(machine, col)) {
              <mat-icon class="tooling-check">check</mat-icon>
              } } @else {
              <span>{{ machineText(machine, col) }}</span>
              }
            </td>
            }
          </tr>
          }
        </table>
      </div>
    </div>
  </div>
  }
</ng-template>
